const QuestNearYou = ({ title, locationNow, bizName, city, country, district }) => {
  return (
    <div className="flex flex-col items-start gap-[12px]">
      {bizName && (
        <p className="text-[#333] font-[Figtree] text-[20px] font-medium not-italic">{bizName}</p>
      )}

      <div className="flex flex-row gap-2 items-center">
        <span className="icon icon-location text-mid-gray" />
        <div className="text-mid-gray font-[Figtree] text-[16px] font-medium not-italic">
          {locationNow && district && city && country ? (
            <span>
              {locationNow}, {district}, {city}, {country}
            </span>
          ) : (
            <span className="text-base">Singapore</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default QuestNearYou;
